module.exports = __webpack_public_path__ + "static/media/29BDOS28.01abd45a.jpg";